import "mapbox-gl/dist/mapbox-gl.css"
import "polyfill"
import "resources/css/main.css"
import "./start.app"

export default "ok"
